/**
 * 提取额外的键值对
 * @example
 * // 调用示例
 * interface MyResource {
 *   cpu?: number | string;
 *   memory?: string;
 *   customResource?: number | string;
 *   anotherResource?: number | string;
 * }
 *
 * const resource: MyResource = {
 *   cpu: '1',
 *   memory: '512Mi',
 *   customResource: 'value1',
 *   anotherResource: 'value2',
 * };
 *
 * console.log(extractExtraResource(resource, ['cpu', 'memory']));
 * // 输出：[
 * //   { key: 'customResource', value: 'value1' },
 * //   { key: 'anotherResource', value: 'value2' },
 * // ]
 * console.log(extractExtraResource(null as any, ['cpu', 'memory'])); // 模拟传入非法对象
 * // 输出：[]
 * @param resource - 资源对象
 * @param fixedKeys - 固定的键
 * @returns 额外的键值对
 */
export function extractExtraResource<T extends Record<string, any>>(
  resource: T,
  fixedKeys: (keyof T)[],
): { key: keyof T | string; value: T[keyof T] | string }[] {
  if (typeof resource !== 'object' || resource === null || Array.isArray(resource)) {
    return [];
  }
  const rest = { ...resource };
  for (const key of fixedKeys) {
    delete rest[key as string];
  }
  return Object.keys(rest).map((key) => ({
    key: key as keyof T,
    value: rest[key],
  }));
}
